import { appConfig, headerConfig, refineHeader } from "../../config";

export const announcementsService = {
  getActiveAnnouncements
};



function getActiveAnnouncements(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}announcements/active`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/announcementsService.js